module.exports = __webpack_public_path__ + "static/offers-2c1a1fb128070e7d503584bb33f01d39.png";